module.exports = __webpack_public_path__ + "img/ics_o_booking_white.64b25dab.svg";